import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';

import { ImageGalleryBlockData } from 'api/cms';
import Slideshow from 'components/Slideshow';
import ScrollContext from 'containers/ScrollContext';

type Props = {
  data: ImageGalleryBlockData;
  blockIndex: number;
};

export function ImageGalleryBlock({ data: { images }, blockIndex }: Props) {
  const [show, setShow] = useState(blockIndex > 2);
  const [, scrollY] = useContext(ScrollContext);
  const lazyRef = useRef(null);

  const update = useCallback(() => {
    if (!show && lazyRef && lazyRef.current) {
      const offsetY = lazyRef.current.getBoundingClientRect().top - 200;
      const inView = offsetY < window.innerHeight + scrollY;

      if (inView && !show) {
        setShow(true);
      }
    }
  }, [scrollY, show]);

  useEffect(() => {
    update();
  }, [scrollY, update]);

  return show ? (
    <Slideshow items={images} data-qa-id="cms-image-gallery" round />
  ) : (
    <div ref={lazyRef} />
  );
}
